import React from 'react';
import styled from 'App/styled';


interface RatingAndReviewCountProps {
  ratingCount: number,
  reviewCount: number,
}

const Text = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
`;

const RatingAndReviewCount = ({
  ratingCount,
  reviewCount,
}: RatingAndReviewCountProps) => (
  <>
    {
      (ratingCount > 0)
      && (<Text>{ratingCount} ratings &nbsp;</Text>)
    }
    {
      (ratingCount > 0 && reviewCount > 0)
      && (<Text>& &nbsp;</Text>)
    }
    {
      (reviewCount > 0)
      && (<Text>{reviewCount} reviews</Text>)
    }
  </>
);

export default RatingAndReviewCount;
